import React, { useState } from 'react';
import './Formatter.less';

const Formatter: React.FC = () => {
  const [puzzleData, setPuzzleData] = useState('');
  const [outputData, setOutputData] = useState('');

  const handleOutputWithBlanks = () => {
    const input = puzzleData.split('\n');
    const maxLength = Math.max(...input.map(line => line.split(' ')[0].length));

    const output = input.map(line => {
      const match = line.match(/^(\S*)(\s*)(.*)$/);
      if (!match) return '';
      const [_, firstWord, , rest] = match;
      const blanks = '_ '.repeat(firstWord.length).trim();
      return blanks.padEnd(maxLength * 2 - 1 + 5) + ' ' + rest;
    }).join('\n');

    setOutputData(output);
  };

  const handleOutputWithSolutions = () => {
    const input = puzzleData.split('\n');
    const maxLength = Math.max(...input.map(line => line.split(' ')[0].length));

    const output = input.map(line => {
      const match = line.match(/^(\S*)(\s*)(.*)$/);
      if (!match) return '';
      const [_, firstWord, , rest] = match;
      return firstWord.toUpperCase().padEnd(maxLength + 5) + ' ' + rest;
    }).join('\n');

    setOutputData(output);
  };

  const handleOutputAsJson = () => {
    const input = puzzleData.split('\n');

    const clues = input.map(line => {
      const match = line.match(/^(\S*)(\s*)(.*)$/);
      if (!match) return { solution: '', clue: '', morph: '' };
      const [_, solution, , clue] = match;
      const clueMatch = clue.trim().match(/^(.*?)(\s*\([^)]*\))?$/);
      const [clueText, morph] = clueMatch ? clueMatch.slice(1, 3) : ['', ''];
      return {
        solution,
        clue: clueText,
        morph: (morph || '()').trim().replace(/^\(|\)$/g, ''),
      };
    });

    const outputObject = { clues };
    setOutputData(JSON.stringify(outputObject, null, 2));
  };

  const handleCopyOutput = () => {
    navigator.clipboard.writeText(outputData).then(() => {
      console.log('Output copied to clipboard');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  };

  return (
    <div className="formatterContainer">
      <div className="formatterInputContainer">
        <label htmlFor="puzzleData">Puzzle Data</label>
        <textarea
          id="puzzleData"
          value={puzzleData}
          onChange={(e) => setPuzzleData(e.target.value)}
          placeholder={`Put your puzzle data here, one clue per line, like so:

LEFT Not right
CLEFT Divided (+1)
CHEF One who prepares food (-1, ~1)`}
        />
        <div className="formatterButtonContainer">
          <button onClick={handleOutputWithBlanks}>Output with Blanks</button>
          <button onClick={handleOutputWithSolutions}>Output with Solutions</button>
          <button onClick={handleOutputAsJson}>Output as JSON</button>
        </div>
      </div>
      <div className="formatterOutputContainer">
        <label htmlFor="outputData">Output</label>
        <pre id="outputData">{outputData}</pre>
        <div className="formatterButtonContainer">
          <button onClick={handleCopyOutput}>Copy to clipboard</button>
        </div>
      </div>
    </div>
  );
};

export default Formatter;
